const accountsView = {
  title: 'Accounts',
  toolbar: {
    create: 'New Account',
    search: 'Search accounts...',
    delete: 'Delete',
    filterType: 'Search types...',
  },
  table: {
    aria: 'Accounts List',
    columns: {
      id: 'ID',
      name: 'Account Name',
      type: 'Type',
      email: 'Email',
      phone: 'Phone',
      relationship: 'Relationship',
      tradeVolume: 'Trade Volume',
    },
    actions: {
      viewDetails: 'View Details',
      edit: 'Edit',
    },
  },
  content: {
    error: 'Error loading accounts: {{message}}',
    noData: 'No accounts available',
  },
  form: {
    sections: {
      accountDetails: 'Account Details',
      primaryAddress: 'Primary Address',
      addresses: 'Addresses & Contacts',
      contacts: 'Contacts',
    },
    fields: {
      name: 'Account Name',
      email: 'Email Address',
      phone: 'Phone Number',
      website: 'Website URL',
      type: 'Account Type',
      notes: 'Notes',
      relationship: 'Business Relationship',
      isCustomer: 'Customer',
      isSupplier: 'Supplier',
      accountManagers: 'Account Managers',
      address: {
        type: 'Address Type',
        types: {
          standard: 'Standard',
          nonStandard: 'Non-Standard',
          poBox: 'PO Box',
        },
        name: 'Name',
        addressName: 'Address name',
        streetAddress: 'Street Address',
        streetAddressPlaceholder: 'e.g. Suite 100, Building A',
        addressLine2: 'Address Line 2',
        addressLine2Placeholder: 'Apt, Suite, Unit, etc.',
        poBoxNumber: 'PO Box Number',
        city: 'City',
        state: 'State / Province',
        postalCode: 'Postal code',
        country: 'Country',
        selectCountry: 'Select country',
        isMailingAddress: 'Mailing address',
        addAddress: 'Add Address',
        noAddresses: 'No addresses added yet',
        namePlaceholder: 'e.g. Main Office, Headquarters',
      },
      contacts: {
        title: 'Contacts',
        addContact: 'Add Contact',
        removeContact: 'Remove Contact',
        fullName: 'Full Name',
        firstName: 'First name',
        lastName: 'Last name',
        addressAs: 'Address As',
        email: 'Email',
        phone: 'Phone',
        role: 'Role',
        department: 'Department',
        notes: 'Notes',
        isPrimary: 'Is primary',
        primaryBadge: 'Primary',
        noContacts: 'No contacts added yet',
        new: 'New',
        qualified: 'Qualified',
        contacted: 'Contacted',
        unqualified: 'Unqualified',
        customer: 'Customer',
        lost: 'Lost',
        formerCustomer: 'Former Customer',
        inactive: 'Inactive',
      },
    },
    placeholders: {
      companyName: 'Company or person name',
      email: 'email@example.com',
      phone: '+1 (555) 123-4567',
      website: 'https://example.com',
      accountManagers: 'Select account managers',
      notes: 'Add notes about this account...',
      addressName: 'e.g. Headquarters, Warehouse',
    },
    type: {
      commercial: 'Commercial',
      individual: 'Individual',
    },
    validation: {
      required: 'This field is required',
      invalidEmail: 'Please enter a valid email address',
      invalidPhone: 'Please enter a valid phone number',
      invalidUrl: 'Please enter a valid URL',
      invalidRelationship: 'Please select at least one relationship type',
    },
  },
  relationship: {
    customer: 'Customer',
    supplier: 'Supplier',
    carrier: 'Carrier',
  },
  deleteDialog: {
    titleSingle: (name: string) => `Delete ${name}?`,
    titleBatch: (count: number) =>
      `Delete ${count} ${count === 1 ? 'account' : 'accounts'}?`,
    cascadeWarning:
      'This will also delete all associated contacts and addresses. This action cannot be undone.',
  },
  dialog: {
    title: {
      create: 'New Account',
      edit: 'Edit Account',
    },
    actions: {
      save: 'Save',
      create: 'Create',
      cancel: 'Cancel',
    },
  },
  addresses: {
    dialog: {
      titleEdit: 'Edit Address',
      titleNew: 'New Address',
    },
    search: 'Search',
    noAddressesFound: 'No addresses found',
  },
  contacts: {
    dialog: {
      titleEdit: 'Edit Contact',
      titleNew: 'New Contact',
    },
  },
  details: {
    inviteCustomer: 'Invite Customer',
    edit: 'Edit',
    inviteSentSuccess: (email: string) =>
      `Customer invitation sent successfully to ${email}`,
    inviteAlreadyLinked:
      'This customer has already been invited or is already linked to an organization',
    inviteNoEmail: 'This account needs an email address to send an invitation',
    inviteFailed: 'Failed to send customer invitation',
  },
  messages: {
    createSuccess: 'Account created successfully',
    updateSuccess: 'Account updated successfully',
    deleteSuccess: 'Account(s) deleted successfully',
    validation: 'Please, fix the errors in the form.',
    error: 'An error occurred while processing your request',
  },
  trade: {
    paymentTerms: 'Default Payment Terms',
    purchasePaymentTerm: 'Purchase Payment Term',
    salesPaymentTerm: 'Sales Payment Term',
    selectPaymentTerm: 'Select payment term...',
    edit: 'Edit',
  },
  emptyState: {
    title: 'No accounts found',
    description:
      "Try adjusting your search or filters to find what you're looking for.",
  },
};

const counterpartyGroups = {
  title: 'Price List Groups',
  addToGroup: 'Add to Group',
  remove: 'Remove',
  emptyState: 'This account is not assigned to any counterparty groups.',
  toast: {
    addSuccess: 'Account added to counterparty group',
    addError: (message: string) => `Failed to add account to group: ${message}`,
    removeSuccess: 'Account removed from counterparty group',
    removeError: (message: string) =>
      `Failed to remove account from group: ${message}`,
  },
};

export const en = {
  accountsView,
  counterpartyGroups,
};
